export default {
  roomsList: [
    'crafts_room',
    'pantry',
    'fish_tank',
    'boiler_room',
    'bulletin_board',
    'vault',
    'abandoned_jojaMart',
  ],

  rooms: {
    crafts_room: {
      name: 'Crafts Room',
      reward: {
        name: 'Bridge Repair',
        url: 'https://stardewvalleywiki.com/Quarry',
      },
      img: 'Bundle_Green.png',
      style: { background: '#9fe2a2' },
      bundleStyle: { background: '#f9fffa' },
      bundles: [
        'spring_foraging',
        'summer_foraging',
        'fall_foraging',
        'winter_foraging',
        'construction',
        'exotic_foraging',
      ],
    },
    pantry: {
      name: 'Pantry',
      reward: {
        name: 'Greenhouse',
        url: 'https://stardewvalleywiki.com/Greenhouse',
      },
      img: 'Bundle_Orange.png',
      style: { background: '#ffb261' },
      bundleStyle: { background: '#fff8f0' },
      bundles: [
        'spring_crops',
        'summer_crops',
        'fall_crops',
        'quality_crops',
        'animal',
        'artisan',
      ],
    },
    fish_tank: {
      name: 'Fish Tank',
      reward: {
        name: 'Glittering Boulder Removed',
        url: 'https://stardewvalleywiki.com/The_Mountain',
      },
      img: 'Bundle_Teal.png',
      style: { background: '#b2d0ff' },
      bundleStyle: { background: '#f3f7ff' },
      bundles: [
        'river_fish',
        'lake_fish',
        'ocean_fish',
        'night_fishing',
        'crab_pot',
        'specialty_fish',
      ],
    },
    boiler_room: {
      name: 'Boiler Room',
      reward: {
        name: 'Minecarts Repaired',
        url: 'https://stardewvalleywiki.com/Minecart',
      },
      img: 'Bundle_Yellow.png',
      style: { background: '#cecece' },
      bundleStyle: { background: '#f7f7f7' },
      bundles: ['blacksmiths', 'geologists', 'adventurers'],
    },
    bulletin_board: {
      name: 'Bulletin Board',
      reward: {
        name: 'Friendship',
        url: 'https://stardewvalleywiki.com/Friendship',
      },
      img: 'Bundle_Green.png',
      style: { background: '#9fe2a2' },
      bundleStyle: { background: '#f9fffa' },
      bundles: ['chefs', 'dye', 'field_research', 'fodder', 'enchanters'],
    },
    vault: {
      name: 'Vault',
      reward: {
        name: 'Bus Repair',
        url: 'https://stardewvalleywiki.com/Bus_Stop',
      },
      img: 'Bundle_Orange.png',
      style: { background: '#ffb261' },
      bundleStyle: { background: '#fff8f0' },
      bundles: ['2500', '5000', '10000', '25000'],
    },
    abandoned_jojaMart: {
      name: 'Abandoned JojaMart',
      reward: {
        name: 'Movie Theater',
        url: 'https://stardewvalleywiki.com/Movie_Theater',
      },
      img: 'Bundle_Teal.png',
      style: { background: '#b2d0ff' },
      bundleStyle: { background: '#f3f7ff' },
      bundles: ['missing'],
    },
  },

  bundles: {
    river_fish: {
      name: 'River Fish',
      reward: {
        item: 'bait',
        quantity: 30,
      },
      items: ['sunfish', 'catfish', 'shad', 'tiger_trout'],
      required: 4,
    },
    lake_fish: {
      name: 'Lake Fish',
      reward: {
        item: 'dressed_spinner',
        quantity: 1,
      },
      items: ['largemouth_bass', 'carp', 'bullhead', 'sturgeon'],
      required: 4,
    },
    ocean_fish: {
      name: 'Ocean Fish',
      reward: {
        item: 'warp_totem_beach',
        quantity: 5,
      },
      items: ['sardine', 'tuna', 'red_snapper', 'tilapia'],
      required: 4,
    },
    night_fishing: {
      name: 'Night Fishing',
      reward: {
        item: 'small_glow_ring',
        quantity: 1,
      },
      items: ['walleye', 'bream', 'eel'],
      required: 3,
    },
    crab_pot: {
      name: 'Crab Pot',
      reward: {
        item: 'crab_pot',
        quantity: 3,
      },
      items: [
        'lobster',
        'crayfish',
        'crab',
        'cockle',
        'mussel',
        'shrimp',
        'snail',
        'oyster',
        'periwinkle',
        'clam',
      ],
      required: 5,
    },
    specialty_fish: {
      name: 'Specialty Fish',
      reward: {
        item: 'dish_o_the_sea',
        quantity: 5,
      },
      items: ['pufferfish', 'ghostfish', 'sandfish', 'woodskip'],
      required: 4,
    },
    spring_foraging: {
      name: 'Spring Foraging',
      reward: {
        item: 'spring_seeds',
        quantity: 30,
      },
      items: ['wild_horseradish', 'daffodil', 'leek', 'dandelion'],
      required: 4,
    },
    summer_foraging: {
      name: 'Summer Foraging',
      reward: {
        item: 'summer_seeds',
        quantity: 30,
      },
      items: ['grape', 'spice_berry', 'sweet_pea'],
      required: 3,
    },
    fall_foraging: {
      name: 'Fall Foraging',
      reward: {
        item: 'fall_seeds',
        quantity: 30,
      },
      items: ['common_mushroom', 'wild_plum', 'hazelnut', 'blackberry'],
      required: 4,
    },
    winter_foraging: {
      name: 'Winter Foraging',
      reward: {
        item: 'winter_seeds',
        quantity: 30,
      },
      items: ['winter_root', 'crystal_fruit', 'snow_yam', 'crocus'],
      required: 4,
    },
    construction: {
      name: 'Construction',
      reward: {
        item: 'charcoal_kiln',
        quantity: 1,
      },
      items: ['wood', 'stone', 'hardwood'],
      quantities: [198, 99, 10],
      required: 3,
    },
    exotic_foraging: {
      name: 'Exotic Foraging',
      reward: {
        item: 'autumns_bounty',
        quantity: 30,
      },
      items: [
        'coconut',
        'cactus_fruit',
        'cave_carrot',
        'red_mushroom',
        'purple_mushroom',
        'maple_syrup',
        'oak_resin',
        'pine_tar',
        'morel',
      ],
      required: 5,
    },
    spring_crops: {
      name: 'Spring Crops',
      reward: {
        item: 'speed_gro',
        quantity: 20,
      },
      items: ['parsnip', 'green_bean', 'cauliflower', 'potato'],
      required: 4,
    },
    summer_crops: {
      name: 'Summer Crops',
      reward: {
        item: 'quality_sprinkler',
        quantity: 1,
      },
      items: ['tomato', 'hot_pepper', 'blueberry', 'melon'],
      required: 4,
    },
    fall_crops: {
      name: 'Fall Crops',
      reward: {
        item: 'bee_house',
        quantity: 1,
      },
      items: ['corn', 'eggplant', 'pumpkin', 'yam'],
      required: 4,
    },
    quality_crops: {
      name: 'Quality Crops (3)',
      reward: {
        item: 'preserves_jar',
        quantity: 1,
      },
      items: ['parsnip_gold', 'melon_gold', 'pumpkin_gold', 'corn_gold'],
      quantities: [5, 5, 5, 5],
      required: 3,
    },
    animal: {
      name: 'Animal',
      reward: {
        item: 'cheese_press',
        quantity: 1,
      },
      items: [
        'large_milk',
        'large_egg_brown',
        'large_egg',
        'large_goat_milk',
        'wool',
        'duck_egg',
      ],
      required: 5,
    },
    artisan: {
      name: 'Artisan',
      reward: {
        item: 'keg',
        quantity: 1,
      },
      items: [
        'truffle_oil',
        'cloth',
        'goat_cheese',
        'cheese',
        'honey',
        'jelly',
        'apple',
        'apricot',
        'orange',
        'peach',
        'pomegranate',
        'cherry',
      ],
      required: 6,
    },
    blacksmiths: {
      name: "Blacksmith's",
      reward: {
        item: 'furnace',
        quantity: 1,
      },
      items: ['copper_bar', 'iron_bar', 'gold_bar'],
      required: 3,
    },
    geologists: {
      name: "Geologist's",
      reward: {
        item: 'omni_geode',
        quantity: 5,
      },
      items: ['quartz', 'earth_crystal', 'frozen_tear', 'fire_quartz'],
      required: 4,
    },
    adventurers: {
      name: "Adventurer's (2)",
      reward: {
        item: 'small_magnet_ring',
        quantity: 1,
      },
      items: ['slime', 'bat_wing', 'solar_essence', 'void_essence'],
      quantities: [99, 10],
      required: 2,
    },
    chefs: {
      name: "Chef's",
      reward: {
        item: 'pink_cake',
        quantity: 3,
      },
      items: [
        'maple_syrup',
        'fiddlehead_fern',
        'truffle',
        'poppy',
        'maki_roll',
        'fried_egg',
      ],
      required: 6,
    },
    dye: {
      name: 'Dye',
      reward: {
        item: 'seed_maker',
        quantity: 1,
      },
      items: [
        'red_mushroom',
        'sea_urchin',
        'sunflower',
        'duck_feather',
        'aquamarine',
        'red_cabbage',
      ],
      required: 6,
    },
    field_research: {
      name: 'Field Research',
      reward: {
        item: 'recycling_machine',
        quantity: 1,
      },
      items: ['purple_mushroom', 'nautilus_shell', 'chub', 'frozen_geode'],
      required: 4,
    },
    fodder: {
      name: 'Fodder',
      reward: {
        item: 'heater',
        quantity: 1,
      },
      items: ['wheat', 'hay', 'apple'],
      quantities: [10, 10, 3],
      required: 3,
    },
    enchanters: {
      name: "Enchanter's",
      reward: {
        item: 'gold_bar',
        quantity: 5,
      },
      items: ['oak_resin', 'wine', 'rabbits_foot', 'pomegranate'],
      required: 4,
    },
    2500: {
      name: '2,500',
      type: 'vault',
      items: ['2500'],
      required: 1,
      reward: {
        item: 'chocolate_cake',
        quantity: 3,
      },
    },
    5000: {
      name: '5,000',
      type: 'vault',
      items: ['5000'],
      required: 1,
      reward: {
        item: 'quality_fertilizer',
        quantity: 30,
      },
    },
    10000: {
      name: '10,000',
      type: 'vault',
      items: ['10000'],
      required: 1,
      reward: {
        item: 'lightning_rod',
        quantity: 1,
      },
    },
    25000: {
      name: '25,000',
      type: 'vault',
      items: ['25000'],
      required: 1,
      reward: {
        item: 'crystalarium',
        quantity: 1,
      },
    },
    missing: {
      name: 'Missing',
      items: [
        'wine_silver',
        'dinosaur_mayonnaise',
        'prismatic_shard',
        'ancient_fruit',
        'void_salmon',
        'caviar',
      ],
      quantities: [null, null, null, 5],
      required: 5,
    },
  },

  items: {
    sunfish: {
      name: 'Sunfish',
      seasons: ['Spring', 'Summer'],
      description: 'Sunny weather, River, 6am - 7pm',
      url: 'https://stardewvalleywiki.com/Sunfish',
      img: 'sunfish.png',
    },
    catfish: {
      name: 'Catfish',
      seasons: ['Spring', 'Fall'],
      description: 'Rainy weather, River or Secret Woods',
      url: 'https://stardewvalleywiki.com/Catfish',
      img: 'catfish.png',
    },
    shad: {
      name: 'Shad',
      seasons: ['Spring', 'Summer', 'Fall'],
      description: 'Rainy weather, River, 9am - 2am',
      url: 'https://stardewvalleywiki.com/Shad',
      img: 'shad.png',
    },
    tiger_trout: {
      name: 'Tiger Trout',
      seasons: ['Spring', 'Fall'],
      description: 'Rainy weather, River, 6am - 7pm',
      url: 'https://stardewvalleywiki.com/Tiger_Trout',
      img: 'tiger_trout.png',
    },
    largemouth_bass: {
      name: 'Largemouth Bass',
      seasons: ['Any'],
      description: 'Mountain Lake, 6am - 7pm',
      url: 'https://stardewvalleywiki.com/Largemouth_Bass',
      img: 'Largemouth_Bass.png',
    },
    carp: {
      name: 'Carp',
      seasons: ['Spring', 'Summer', 'Fall'],
      description: 'Mountain Lake (Secret Woods/Sewer, anytime)',
      url: 'https://stardewvalleywiki.com/Carp',
      img: 'Carp.png',
    },
    bullhead: {
      name: 'Bullhead',
      seasons: ['Any'],
      description: 'Mountain Lake',
      url: 'https://stardewvalleywiki.com/Bullhead',
      img: 'Bullhead.png',
    },
    sturgeon: {
      name: 'Sturgeon',
      seasons: ['Summer', 'Winter'],
      description: 'Mountain Lake, 6am - 7pm',
      url: 'https://stardewvalleywiki.com/Sturgeon',
      img: 'Sturgeon.png',
    },
    sardine: {
      name: 'Sardine',
      seasons: ['Spring', 'Fall', 'Winter'],
      description: 'Ocean, 6am - 7pm',
      url: 'https://stardewvalleywiki.com/Sardine',
      img: 'Sardine.png',
    },
    tuna: {
      name: 'Tuna',
      seasons: ['Summer', 'Winter'],
      description: 'Ocean, 6am - 7pm',
      url: 'https://stardewvalleywiki.com/Tuna',
      img: 'Tuna.png',
    },
    red_snapper: {
      name: 'Red Snapper',
      seasons: ['Summer', 'Fall'],
      description: 'Rainy weather, Ocean, 6am - 7pm',
      url: 'https://stardewvalleywiki.com/Red_Snapper',
      img: 'Red_Snapper.png',
    },
    tilapia: {
      name: 'Tilapia',
      seasons: ['Summer', 'Fall'],
      description: 'Ocean, 6am - 2pm',
      url: 'https://stardewvalleywiki.com/Tilapia',
      img: 'Tilapia.png',
    },
    walleye: {
      name: 'Walleye',
      seasons: ['Fall'],
      description: 'Rainy weather, River or Lake, 12pm - 2am',
      url: 'https://stardewvalleywiki.com/Walleye',
      img: 'Walleye.png',
    },
    bream: {
      name: 'Bream',
      seasons: ['Any'],
      description: 'River, 6am - 2am',
      url: 'https://stardewvalleywiki.com/Bream',
      img: 'Bream.png',
    },
    eel: {
      name: 'Eel',
      seasons: ['Spring', 'Fall'],
      description: 'Rainy weather, Ocean, 4pm - 2am',
      url: 'https://stardewvalleywiki.com/Eel',
      img: 'Eel.png',
    },
    lobster: {
      name: 'Lobster',
      description: 'Crab pots, Ocean',
      url: 'https://stardewvalleywiki.com/Lobster',
      img: 'Lobster.png',
    },
    crayfish: {
      name: 'Crayfish',
      description: 'Crab pots, freshwater',
      url: 'https://stardewvalleywiki.com/Crayfish',
      img: 'Crayfish.png',
    },
    crab: {
      name: 'Crab',
      description: 'Crab pots, Ocean (or Mine)',
      url: 'https://stardewvalleywiki.com/Crab',
      img: 'Crab.png',
    },
    cockle: {
      name: 'Cockle',
      description: 'Crab pots, Ocean (or Beach foraging)',
      url: 'https://stardewvalleywiki.com/Cockle',
      img: 'Cockle.png',
    },
    mussel: {
      name: 'Mussel',
      description: 'Crab pots, Ocean (or Beach foraging)',
      url: 'https://stardewvalleywiki.com/Mussel',
      img: 'Mussel.png',
    },
    shrimp: {
      name: 'Shrimp',
      description: 'Crab pots, Ocean',
      url: 'https://stardewvalleywiki.com/Shrimp',
      img: 'Shrimp.png',
    },
    snail: {
      name: 'Snail',
      description: 'Crab pots, freshwater',
      url: 'https://stardewvalleywiki.com/Snail',
      img: 'Snail.png',
    },
    periwinkle: {
      name: 'Periwinkle',
      description: 'Crab pots, freshwater',
      url: 'https://stardewvalleywiki.com/Periwinkle',
      img: 'Periwinkle.png',
    },
    oyster: {
      name: 'Oyster',
      description: 'Crab pots, Ocean (or Beach foraging)',
      url: 'https://stardewvalleywiki.com/Oyster',
      img: 'Oyster.png',
    },
    clam: {
      name: 'Clam',
      description: 'Crab pots, Ocean (or Beach foraging)',
      url: 'https://stardewvalleywiki.com/Clam',
      img: 'Clam.png',
    },
    pufferfish: {
      name: 'Pufferfish',
      seasons: ['Summer'],
      description: 'Sunny weather, Ocean',
      url: 'https://stardewvalleywiki.com/Pufferfish',
      img: 'Pufferfish.png',
    },
    ghostfish: {
      name: 'Ghostfish',
      seasons: ['Any'],
      description: 'Mines, floors 20 and 60',
      url: 'https://stardewvalleywiki.com/Ghostfish',
      img: 'Ghostfish.png',
    },
    sandfish: {
      name: 'Sandfish',
      seasons: ['Any'],
      description: 'Desert, 6am - 8pm',
      url: 'https://stardewvalleywiki.com/Sandfish',
      img: 'Sandfish.png',
    },
    woodskip: {
      name: 'Woodskip',
      seasons: ['Any'],
      description: 'Secret Woods',
      url: 'https://stardewvalleywiki.com/Woodskip',
      img: 'Woodskip.png',
    },
    wild_horseradish: {
      name: 'Wild Horseradish',
      seasons: ['Spring'],
      description: 'Foraging',
      url: 'https://stardewvalleywiki.com/Wild_Horseradish',
      img: 'Wild_Horseradish.png',
    },
    daffodil: {
      name: 'Daffodil',
      seasons: ['Spring'],
      description: 'Foraging, Pierre at Flower Dance',
      url: 'https://stardewvalleywiki.com/Daffodil',
      img: 'Daffodil.png',
    },
    leek: {
      name: 'Leek',
      seasons: ['Spring'],
      description: 'Foraging',
      url: 'https://stardewvalleywiki.com/Leek',
      img: 'Leek.png',
    },
    dandelion: {
      name: 'Dandelion',
      seasons: ['Spring'],
      description: 'Foraging',
      url: 'https://stardewvalleywiki.com/Dandelion',
      img: 'Dandelion.png',
    },
    grape: {
      name: 'Grape',
      seasons: ['Summer'],
      description: 'Foraging',
      url: 'https://stardewvalleywiki.com/Grape',
      img: 'Grape.png',
    },
    spice_berry: {
      name: 'Spice Berry',
      seasons: ['Summer'],
      description: 'Foraging, Farm Cave',
      url: 'https://stardewvalleywiki.com/Spice_Berry',
      img: 'Spice_Berry.png',
    },
    sweet_pea: {
      name: 'Sweet Pea',
      seasons: ['Summer'],
      description: 'Foraging',
      url: 'https://stardewvalleywiki.com/Sweet_Pea',
      img: 'Sweet_Pea.png',
    },
    common_mushroom: {
      name: 'Common Mushroom',
      seasons: ['Fall'],
      description: 'Foraging, Farm Cave, tap Mushroom Tree',
      url: 'https://stardewvalleywiki.com/Common_Mushroom',
      img: 'Common_Mushroom.png',
    },
    wild_plum: {
      name: 'Wild Plum',
      seasons: ['Fall'],
      description: 'Foraging, Farm Cave',
      url: 'https://stardewvalleywiki.com/Wild_Plum',
      img: 'Wild_Plum.png',
    },
    hazelnut: {
      name: 'Hazelnut',
      seasons: ['Fall'],
      description: 'Foraging',
      url: 'https://stardewvalleywiki.com/Hazelnut',
      img: 'Hazelnut.png',
    },
    blackberry: {
      name: 'Blackberry',
      seasons: ['Fall'],
      description: 'Foraging, Farm Cave',
      url: 'https://stardewvalleywiki.com/Blackberry',
      img: 'Blackberry.png',
    },
    winter_root: {
      name: 'Winter Root',
      seasons: ['Winter'],
      description: 'Tilling soil, floors 41 - 79 of Mines',
      url: 'https://stardewvalleywiki.com/Winter_Root',
      img: 'Winter_Root.png',
    },
    crystal_fruit: {
      name: 'Crystal Fruit',
      seasons: ['Winter'],
      description: 'Foraging, floors 41 - 79 of Mines',
      url: 'https://stardewvalleywiki.com/Crystal_Fruit',
      img: 'Crystal_Fruit.png',
    },
    snow_yam: {
      name: 'Snow Yam',
      seasons: ['Winter'],
      description: 'Tilling soil',
      url: 'https://stardewvalleywiki.com/Snow_Yam',
      img: 'Snow_Yam.png',
    },
    crocus: {
      name: 'Crocus',
      seasons: ['Winter'],
      description: 'Foraging',
      url: 'https://stardewvalleywiki.com/Crocus',
      img: 'Crocus.png',
    },
    wood: {
      name: 'Wood',
      description: 'Chopping trees or branches',
      url: 'https://stardewvalleywiki.com/Wood',
      img: 'Wood.png',
    },
    stone: {
      name: 'Stone',
      description: 'Mining stones',
      url: 'https://stardewvalleywiki.com/Stone',
      img: 'Stone.png',
    },
    hardwood: {
      name: 'Hardwood',
      description: 'Chopping Large Stumps/Logs or crates in the Mines',
      url: 'https://stardewvalleywiki.com/Hardwood',
      img: 'Hardwood.png',
    },
    coconut: {
      name: 'Coconut',
      description: 'Desert foraging',
      url: 'https://stardewvalleywiki.com/Coconut',
      img: 'Coconut.png',
    },
    cactus_fruit: {
      name: 'Cactus Fruit',
      description: 'Desert foraging',
      url: 'https://stardewvalleywiki.com/Cactus_Fruit',
      img: 'Cactus_Fruit.png',
    },
    cave_carrot: {
      name: 'Cave Carrot',
      description: 'Tilling soil in the Mines',
      url: 'https://stardewvalleywiki.com/Cave_Carrot',
      img: 'Cave_Carrot.png',
    },
    red_mushroom: {
      name: 'Red Mushroom',
      description: 'Mines, Farm Cave, tap Mushroom Tree',
      url: 'https://stardewvalleywiki.com/Red_Mushroom',
      img: 'Red_Mushroom.png',
    },
    purple_mushroom: {
      name: 'Purple Mushroom',
      description: 'Mines, Farm Cave',
      url: 'https://stardewvalleywiki.com/Purple_Mushroom',
      img: 'Purple_Mushroom.png',
    },
    maple_syrup: {
      name: 'Maple Syrup',
      description: 'Tap Maple Tree',
      url: 'https://stardewvalleywiki.com/Maple_Syrup',
      img: 'Maple_Syrup.png',
    },
    oak_resin: {
      name: 'Oak Resin',
      description: 'Tap Oak Tree',
      url: 'https://stardewvalleywiki.com/Oak_Resin',
      img: 'Oak_Resin.png',
    },
    pine_tar: {
      name: 'Pine Tar',
      description: 'Tap Pine Tree',
      url: 'https://stardewvalleywiki.com/Pine_Tar',
      img: 'Pine_Tar.png',
    },
    morel: {
      name: 'Morel',
      description: 'Forage in Secret Woods, Farm Cave',
      url: 'https://stardewvalleywiki.com/Morel',
      img: 'Morel.png',
    },
    spring_seeds: {
      name: 'Spring Seeds',
      url: 'https://stardewvalleywiki.com/Spring_Seeds',
      img: 'Spring_Seeds.png',
    },
    summer_seeds: {
      name: 'Summer Seeds',
      url: 'https://stardewvalleywiki.com/Summer_Seeds',
      img: 'Summer_Seeds.png',
    },
    fall_seeds: {
      name: 'Fall Seeds',
      url: 'https://stardewvalleywiki.com/Fall_Seeds',
      img: 'Fall_Seeds.png',
    },
    winter_seeds: {
      name: 'Winter Seeds',
      url: 'https://stardewvalleywiki.com/Winter_Seeds',
      img: 'Winter_Seeds.png',
    },
    charcoal_kiln: {
      name: 'Charcoal Kiln',
      url: 'https://stardewvalleywiki.com/Charcoal_Kiln',
      img: 'Charcoal_Kiln.png',
    },
    autumns_bounty: {
      name: "Autumn's Bounty",
      url: "https://stardewvalleywiki.com/Autumn's_Bounty",
      img: 'Autumns_Bounty.png',
    },
    bait: {
      name: 'Bait',
      url: 'https://stardewvalleywiki.com/Bait',
      img: 'Bait.png',
    },
    dressed_spinner: {
      name: 'Dressed Spinner',
      url: 'https://stardewvalleywiki.com/Dressed_Spinner',
      img: 'Dressed_Spinner.png',
    },
    warp_totem_beach: {
      name: 'Warp Totem: Beach',
      url: 'https://stardewvalleywiki.com/Warp_Totem_Beach',
      img: 'Warp_Totem_Beach.png',
    },
    small_glow_ring: {
      name: 'Small Glow Ring',
      url: 'https://stardewvalleywiki.com/Small_Glow_Ring',
      img: 'Small_Glow_Ring.png',
    },
    crab_pot: {
      name: 'Crab Pot',
      url: 'https://stardewvalleywiki.com/Crab_Pot',
      img: 'Crab_Pot.png',
    },
    dish_o_the_sea: {
      name: "Dish o' The Sea",
      url: "https://stardewvalleywiki.com/Dish_o'_The_Sea",
      img: 'Dish_o_The_Sea.png',
    },
    parsnip: {
      name: 'Parsnip',
      seasons: ['Spring'],
      description: 'Crops',
      url: 'https://stardewvalleywiki.com/Parsnip',
      img: 'Parsnip.png',
    },
    parsnip_gold: {
      name: 'Parsnip',
      seasons: ['Spring'],
      description: 'Gold quality Crops',
      url: 'https://stardewvalleywiki.com/Parsnip',
      img: 'Parsnip_Gold.png',
    },
    green_bean: {
      name: 'Green Bean',
      seasons: ['Spring'],
      description: 'Crops',
      url: 'https://stardewvalleywiki.com/Green_Bean',
      img: 'Green_Bean.png',
    },
    cauliflower: {
      name: 'Cauliflower',
      seasons: ['Spring'],
      description: 'Crops',
      url: 'https://stardewvalleywiki.com/Cauliflower',
      img: 'Cauliflower.png',
    },
    potato: {
      name: 'Potato',
      seasons: ['Spring'],
      description: 'Crops',
      url: 'https://stardewvalleywiki.com/Potato',
      img: 'Potato.png',
    },
    tomato: {
      name: 'Tomato',
      seasons: ['Summer'],
      description: 'Crops',
      url: 'https://stardewvalleywiki.com/Tomato',
      img: 'Tomato.png',
    },
    hot_pepper: {
      name: 'Hot Pepper',
      seasons: ['Summer'],
      description: 'Crops',
      url: 'https://stardewvalleywiki.com/Hot_Pepper',
      img: 'Hot_Pepper.png',
    },
    blueberry: {
      name: 'Blueberry',
      seasons: ['Summer'],
      description: 'Crops',
      url: 'https://stardewvalleywiki.com/Blueberry',
      img: 'Blueberry.png',
    },
    melon: {
      name: 'Melon',
      seasons: ['Summer'],
      description: 'Crops',
      url: 'https://stardewvalleywiki.com/Melon',
      img: 'Melon.png',
    },
    melon_gold: {
      name: 'Melon',
      seasons: ['Summer'],
      description: 'Gold quality Crops',
      url: 'https://stardewvalleywiki.com/Melon',
      img: 'Melon_Gold.png',
    },
    corn: {
      name: 'Corn',
      seasons: ['Fall'],
      description: 'Crops',
      url: 'https://stardewvalleywiki.com/Corn',
      img: 'Corn.png',
    },
    corn_gold: {
      name: 'Corn',
      seasons: ['Fall'],
      description: 'Gold quality Crops',
      url: 'https://stardewvalleywiki.com/Corn',
      img: 'Corn_Gold.png',
    },
    eggplant: {
      name: 'Eggplant',
      seasons: ['Fall'],
      description: 'Crops',
      url: 'https://stardewvalleywiki.com/Eggplant',
      img: 'Eggplant.png',
    },
    pumpkin: {
      name: 'Pumpkin',
      seasons: ['Fall'],
      description: 'Crops',
      url: 'https://stardewvalleywiki.com/Pumpkin',
      img: 'Pumpkin.png',
    },
    pumpkin_gold: {
      name: 'Pumpkin',
      seasons: ['Fall'],
      description: 'Gold quality Crops',
      url: 'https://stardewvalleywiki.com/Pumpkin',
      img: 'Pumpkin_Gold.png',
    },
    yam: {
      name: 'Yam',
      seasons: ['Fall'],
      description: 'Crops',
      url: 'https://stardewvalleywiki.com/Yam',
      img: 'Yam.png',
    },
    wool: {
      name: 'Wool',
      description: 'Sheep, Rabbits',
      url: 'https://stardewvalleywiki.com/Wool',
      img: 'Wool.png',
    },
    large_milk: {
      name: 'Large Milk',
      description: 'Cows',
      url: 'https://stardewvalleywiki.com/Large_Milk',
      img: 'Large_Milk.png',
    },
    large_egg: {
      name: 'Large Egg',
      description: 'Chickens',
      url: 'https://stardewvalleywiki.com/Large_Egg',
      img: 'Large_Egg.png',
    },
    large_goat_milk: {
      name: 'Large Goat Milk',
      description: 'Goats',
      url: 'https://stardewvalleywiki.com/Large_Goat_Milk',
      img: 'Large_Goat_Milk.png',
    },
    large_egg_brown: {
      name: 'Large Egg (Brown)',
      description: 'Chickens',
      url: 'https://stardewvalleywiki.com/Large_Egg',
      img: 'Large_Brown_Egg.png',
    },
    duck_egg: {
      name: 'Duck Egg',
      description: 'Ducks',
      url: 'https://stardewvalleywiki.com/Duck_Egg',
      img: 'Duck_Egg.png',
    },
    truffle_oil: {
      name: 'Truffle Oil',
      description: 'Made from Truffles using Oil Maker',
      url: 'https://stardewvalleywiki.com/Truffle_Oil',
      img: 'Truffle_Oil.png',
    },
    cloth: {
      name: 'Cloth',
      description: 'Loom, recycling Soggy Newspaper',
      url: 'https://stardewvalleywiki.com/Cloth',
      img: 'Cloth.png',
    },
    goat_cheese: {
      name: 'Goat Cheese',
      description: 'Cheese Press',
      url: 'https://stardewvalleywiki.com/Goat_Cheese',
      img: 'Goat_Cheese.png',
    },
    cheese: {
      name: 'Cheese',
      description: 'Cheese Press',
      url: 'https://stardewvalleywiki.com/Cheese',
      img: 'Cheese.png',
    },
    honey: {
      name: 'Honey',
      description: 'Bee House, Oasis',
      url: 'https://stardewvalleywiki.com/Honey',
      img: 'Honey.png',
    },
    jelly: {
      name: 'Jelly',
      description: 'Preserves Jar',
      url: 'https://stardewvalleywiki.com/Jelly',
      img: 'Jelly.png',
    },
    apple: {
      name: 'Apple',
      seasons: ['Fall'],
      description: 'Farm Cave any season',
      url: 'https://stardewvalleywiki.com/Apple',
      img: 'Apple.png',
    },
    apricot: {
      name: 'Apricot',
      seasons: ['Spring'],
      description: 'Farm Cave any season',
      url: 'https://stardewvalleywiki.com/Apricot',
      img: 'Apricot.png',
    },
    orange: {
      name: 'Orange',
      seasons: ['Summer'],
      description: 'Farm Cave any season',
      url: 'https://stardewvalleywiki.com/Orange',
      img: 'Orange.png',
    },
    peach: {
      name: 'Peach',
      seasons: ['Summer'],
      description: 'Farm Cave any season',
      url: 'https://stardewvalleywiki.com/Peach',
      img: 'Peach.png',
    },
    pomegranate: {
      name: 'Pomegranate',
      seasons: ['Fall'],
      description: 'Farm Cave any season',
      url: 'https://stardewvalleywiki.com/Pomegranate',
      img: 'Pomegranate.png',
    },
    cherry: {
      name: 'Cherry',
      seasons: ['Spring'],
      description: 'Farm Cave any season',
      url: 'https://stardewvalleywiki.com/Cherry',
      img: 'Cherry.png',
    },
    speed_gro: {
      name: 'Speed-Gro',
      url: 'https://stardewvalleywiki.com/Speed_Gro',
      img: 'Speed-Gro.png',
    },
    quality_sprinkler: {
      name: 'Quality Sprinkler',
      url: 'https://stardewvalleywiki.com/Quality_Sprinkler',
      img: 'Quality_Sprinkler.png',
    },
    bee_house: {
      name: 'Bee House',
      url: 'https://stardewvalleywiki.com/Bee_House',
      img: 'Bee_House.png',
    },
    preserves_jar: {
      name: 'Preserves Jar',
      url: 'https://stardewvalleywiki.com/Preserves_Jar',
      img: 'Preserves_Jar.png',
    },
    cheese_press: {
      name: 'Cheese Press',
      url: 'https://stardewvalleywiki.com/Cheese_Press',
      img: 'Cheese_Press.png',
    },
    keg: {
      name: 'Keg',
      url: 'https://stardewvalleywiki.com/Keg',
      img: 'Keg.png',
    },
    wine: {
      name: 'Wine',
      description: 'Keg',
      url: 'https://stardewvalleywiki.com/Wine',
      img: 'Wine.png',
    },
    wine_silver: {
      name: 'Wine',
      description: 'Cask',
      url: 'https://stardewvalleywiki.com/Wine',
      img: 'Wine_Silver.png',
    },
    dinosaur_mayonnaise: {
      name: 'Dinosaur Mayonnaise',
      description: 'Mayonnaise Machine',
      url: 'https://stardewvalleywiki.com/Dinosaur_Mayonnaise',
      img: 'Dinosaur_Mayonnaise.png',
    },
    prismatic_shard: {
      name: 'Prismatic Shard',
      description: 'Mining',
      url: 'https://stardewvalleywiki.com/Prismatic_Shard',
      img: 'Prismatic_Shard.png',
    },
    ancient_fruit: {
      name: 'Ancient Fruit',
      seasons: ['Spring', 'Summer', 'Fall'],
      description: 'Gold quality Crops',
      url: 'https://stardewvalleywiki.com/Ancient_Fruit',
      img: 'Ancient_Fruit_Gold.png',
    },
    void_salmon: {
      name: 'Void Salmon',
      description: "Fishing in Witch's Swamp",
      url: 'https://stardewvalleywiki.com/Void_Salmon',
      img: 'Void_Salmon_Gold.png',
    },
    caviar: {
      name: 'Caviar',
      description: 'Perserves Jar',
      url: 'https://stardewvalleywiki.com/Caviar',
      img: 'Caviar.png',
    },
    crystalarium: {
      name: 'Crystalarium',
      url: 'https://stardewvalleywiki.com/Crystalarium',
      img: 'Crystalarium.png',
    },
    gold: {
      name: 'Gold',
      description: 'Purchase this bundle with Gold',
      url: 'https://stardewvalleywiki.com/Gold',
      img: 'Gold.png',
    },
    lightning_rod: {
      name: 'Lightning Rod',
      url: 'https://stardewvalleywiki.com/Lightning_Rod',
      img: 'Lightning_Rod.png',
    },
    quality_fertilizer: {
      name: 'Quality Fertilizer',
      url: 'https://stardewvalleywiki.com/Quality_Fertilizer',
      img: 'Quality_Fertilizer.png',
    },
    chocolate_cake: {
      name: 'Chocolate Cake',
      url: 'https://stardewvalleywiki.com/Chocolate_Cake',
      img: 'Chocolate_Cake.png',
    },
    rabbits_foot: {
      name: 'Rabbits Foot',
      description: 'Rabbits',
      url: 'https://stardewvalleywiki.com/Rabbits_Foot',
      img: 'Rabbits_Foot.png',
    },
    wheat: {
      name: 'Wheat',
      seasons: ['Summer', 'Fall'],
      description: 'Crops',
      url: 'https://stardewvalleywiki.com/Wheat',
      img: 'Wheat.png',
    },
    hay: {
      name: 'Hay',
      description: "Marnie's Ranch, Grass/Wheat",
      url: 'https://stardewvalleywiki.com/Hay',
      img: 'Hay.png',
    },
    nautilus_shell: {
      name: 'Nautilus Shell',
      seasons: ['Winter'],
      description: 'Beach Foraging',
      url: 'https://stardewvalleywiki.com/Nautilus_Shell',
      img: 'Nautilus_Shell.png',
    },
    chub: {
      name: 'Chub',
      description: 'Mountain Lake, anytime',
      url: 'https://stardewvalleywiki.com/Chub',
      img: 'Chub.png',
    },
    frozen_geode: {
      name: 'Frozen Geode',
      description: 'Mines, floors 40 - 79',
      url: 'https://stardewvalleywiki.com/Frozen_Geode',
      img: 'Frozen_Geode.png',
    },
    heater: {
      name: 'Heater',
      url: 'https://stardewvalleywiki.com/Heater',
      img: 'Heater.png',
    },
    recycling_machine: {
      name: 'Recycling Machine',
      url: 'https://stardewvalleywiki.com/Recycling_Machine',
      img: 'Recycling_Machine.png',
    },
    sea_urchin: {
      name: 'Sea Urchin',
      description: 'Beach Foraging',
      url: 'https://stardewvalleywiki.com/Sea_Urchin',
      img: 'Sea_Urchin.png',
    },
    sunflower: {
      name: 'Sunflower',
      seasons: ['Summer', 'Fall'],
      description: 'Crops',
      url: 'https://stardewvalleywiki.com/Sunflower',
      img: 'Sunflower.png',
    },
    duck_feather: {
      name: 'Duck Feather',
      description: 'Ducks',
      url: 'https://stardewvalleywiki.com/Duck_Feather',
      img: 'Duck_Feather.png',
    },
    aquamarine: {
      name: 'Aquamarine',
      description: 'Mines',
      url: 'https://stardewvalleywiki.com/Aquamarine',
      img: 'Aquamarine.png',
    },
    red_cabbage: {
      name: 'Red Cabbage',
      seasons: ['Summer'],
      description: 'Crops',
      url: 'https://stardewvalleywiki.com/Red_Cabbage',
      img: 'Red_Cabbage.png',
    },
    seed_maker: {
      name: 'Seed Maker',
      url: 'https://stardewvalleywiki.com/Seed_Maker',
      img: 'Seed_Maker.png',
    },
    pink_cake: {
      name: 'Pink Cake',
      url: 'https://stardewvalleywiki.com/Pink_Cake',
      img: 'Pink_Cake.png',
    },
    fiddlehead_fern: {
      name: 'Fiddlehead Fern',
      seasons: ['Summer'],
      description: 'Foraging in Secret Woods',
      url: 'https://stardewvalleywiki.com/Fiddlehead_Fern',
      img: 'Fiddlehead_Fern.png',
    },
    truffle: {
      name: 'Truffle',
      description: 'Pigs',
      url: 'https://stardewvalleywiki.com/Truffle',
      img: 'Truffle.png',
    },
    poppy: {
      name: 'Poppy',
      seasons: ['Summer'],
      description: 'Crops',
      url: 'https://stardewvalleywiki.com/Poppy',
      img: 'Poppy.png',
    },
    maki_roll: {
      name: 'Maki Roll',
      description: 'Cooking',
      url: 'https://stardewvalleywiki.com/Maki_Roll',
      img: 'Maki_Roll.png',
    },
    fried_egg: {
      name: 'Fried Egg',
      description: 'Cooking',
      url: 'https://stardewvalleywiki.com/Fried_Egg',
      img: 'Fried_Egg.png',
    },
    slime: {
      name: 'Slime',
      description: 'Dropped by Slimes',
      url: 'https://stardewvalleywiki.com/Slime',
      img: 'Slime.png',
    },
    bat_wing: {
      name: 'Bat Wing',
      description: 'Bats in the Mines',
      url: 'https://stardewvalleywiki.com/Bat_Wing',
      img: 'Bat_Wing.png',
    },
    solar_essence: {
      name: 'Solar Essence',
      description: 'Mines',
      url: 'https://stardewvalleywiki.com/Solar_Essence',
      img: 'Solar_Essence.png',
    },
    void_essence: {
      name: 'Void Essence',
      description: 'Mines',
      url: 'https://stardewvalleywiki.com/Void_Essence',
      img: 'Void_Essence.png',
    },
    small_magnet_ring: {
      name: 'Small Magnet Ring',
      url: 'https://stardewvalleywiki.com/Small_Magnet_Ring',
      img: 'Small_Magnet_Ring.png',
    },
    quartz: {
      name: 'Quartz',
      description: 'Mines',
      url: 'https://stardewvalleywiki.com/Quartz',
      img: 'Quartz.png',
    },
    earth_crystal: {
      name: 'Earth Crystal',
      description: 'Mines, floors 1 - 39',
      url: 'https://stardewvalleywiki.com/Earth_Crystal',
      img: 'Earth_Crystal.png',
    },
    frozen_tear: {
      name: 'Frozen Tear',
      description: 'Mines, floors 40 - 79',
      url: 'https://stardewvalleywiki.com/Frozen_Tear',
      img: 'Frozen_Tear.png',
    },
    fire_quartz: {
      name: 'Fire Quartz',
      description: 'Mines, floors 80 - 120',
      url: 'https://stardewvalleywiki.com/Fire_Quartz',
      img: 'Fire_Quartz.png',
    },
    omni_geode: {
      name: 'Omni Geode',
      url: 'https://stardewvalleywiki.com/Omni_Geode',
      img: 'Omni_Geode.png',
    },
    copper_bar: {
      name: 'Copper Bar',
      description: 'Smelting Copper Ore',
      url: 'https://stardewvalleywiki.com/Copper_Bar',
      img: 'Copper_Bar.png',
    },
    iron_bar: {
      name: 'Iron Bar',
      description: 'Smelting Iron Ore',
      url: 'https://stardewvalleywiki.com/Iron_Bar',
      img: 'Iron_Bar.png',
    },
    gold_bar: {
      name: 'Gold Bar',
      description: 'Smelting Gold Ore',
      url: 'https://stardewvalleywiki.com/Gold_Bar',
      img: 'Gold_Bar.png',
    },
    furnace: {
      name: 'Furnace',
      url: 'https://stardewvalleywiki.com/Furnace',
      img: 'Furnace.png',
    },
  },
}
